import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import { CryptoStorage } from "@webcrypto/storage";
var encodeToSHA256 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
    var textAsBuffer, hashBuffer, hashArray, digest;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          textAsBuffer = new TextEncoder().encode(id);
          _context.next = 3;
          return window.crypto.subtle.digest("SHA-256", textAsBuffer);
        case 3:
          hashBuffer = _context.sent;
          hashArray = Array.from(new Uint8Array(hashBuffer));
          digest = hashArray.map(function (b) {
            return b.toString(16).padStart(2, "0");
          }).join("");
          return _context.abrupt("return", digest);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function encodeToSHA256(_x) {
    return _ref.apply(this, arguments);
  };
}();
var startSafeStorage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
    var digest;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return encodeToSHA256("" + id);
        case 2:
          digest = _context2.sent;
          return _context2.abrupt("return", digest ? new CryptoStorage(digest) : {});
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function startSafeStorage(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default startSafeStorage;